import { render, staticRenderFns } from "./asideNews.vue?vue&type=template&id=241cae74&scoped=true&"
import script from "./asideNews.vue?vue&type=script&lang=js&"
export * from "./asideNews.vue?vue&type=script&lang=js&"
import style0 from "./asideNews.vue?vue&type=style&index=0&id=241cae74&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "241cae74",
  null
  
)

export default component.exports